import { render } from "./editAdmin.vue?vue&type=template&id=3c7089d6&scoped=true"
import script from "./editAdmin.vue?vue&type=script&lang=js"
export * from "./editAdmin.vue?vue&type=script&lang=js"

import "./editAdmin.vue?vue&type=style&index=0&id=3c7089d6&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7089d6"]])

export default __exports__